module.exports = __webpack_public_path__ + "res/28-img_back_rtl.b4fec54475cb635af3c9740b31d753c3.png";